import EnvConfig from './envConfig';

const GnavAuthConfig = {
  msalConfig: {
    auth: {
      clientId: EnvConfig.gnavAuth.clientId,
      authority: `https://login.microsoftonline.com/${EnvConfig.gnavAuth.tenantId}`,
            redirectUrl: EnvConfig.gnavAuth.redirectUrl
        },
        cache: {
            cacheLocation: "localStorage", 
            storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            secureCookies: true
        }
  },
  scopes: [EnvConfig.gnavAuth.apiScope],
  gnavHeaderEndpoint: EnvConfig.gnavAuth.gnavHeaderEndpoint,
  domainHint: EnvConfig.gnavAuth.domainHint,
};

export default GnavAuthConfig;
